export function extractInvitationToken(error: string | null): string | null {
  if (!error) return null;
  const match = error.match(/InvitationToken:\s*(\w+)/);
  return match ? match[1].trim() : null;
}
